export const Data = [
  {
    id: 1,
    title: "book1",
    author: "author1",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81eB%2B7%2BCkUL._AC_UL200_SR200,200_.jpg",
  },
  {
    id: 2,
    title: "book2",
    author: "author2",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71aLultW5EL._AC_UL200_SR200,200_.jpg",
  },
];
